module.exports = __webpack_public_path__ + "f88a38bc51801d9af90e39aec68f1c10.jpg";